<!-- Container -->
<div class="kt-container-fixed flex items-center justify-between gap-2">
	<div class="grid">
		<div class="kt-scrollable-x-auto">
			<div class="kt-menu gap-5 lg:gap-7.5" data-kt-menu="true">
				<div class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent"
					data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
					data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
					<div class="kt-menu-link gap-1.5 pb-2 lg:pb-4" tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							Account Home
						</span>
						<span class="kt-menu-arrow">
							<i class="ki-filled ki-down text-xs text-muted-foreground">
							</i>
						</span>
					</div>
					<div class="kt-menu-dropdown kt-menu-default min-w-[200px] py-2">
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#" tabindex="0">
								<span class="kt-menu-title">
									Dashboard
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Get Started
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									User Profile
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Company Profile
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Settings - With Sidebar
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Settings - Enterprise
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Settings - Plain
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Settings - Modal
								</span>
							</a>
						</div>
					</div>
				</div>
				<div class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent"
					data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
					data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
					<div class="kt-menu-link gap-1.5 pb-2 lg:pb-4" tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							Billing
						</span>
						<span class="kt-menu-arrow">
							<i class="ki-filled ki-down text-xs text-muted-foreground">
							</i>
						</span>
					</div>
					<div class="kt-menu-dropdown kt-menu-default min-w-[200px] py-2">
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#" tabindex="0">
								<span class="kt-menu-title">
									Billing - Basic
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Billing - Enterprise
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#" tabindex="0">
								<span class="kt-menu-title">
									Plans
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Billing History
								</span>
							</a>
						</div>
					</div>
				</div>
				<div class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent"
					data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
					data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
					<div class="kt-menu-link gap-1.5 pb-2 lg:pb-4" tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							Security
						</span>
						<span class="kt-menu-arrow">
							<i class="ki-filled ki-down text-xs text-muted-foreground">
							</i>
						</span>
					</div>
					<div class="kt-menu-dropdown kt-menu-default min-w-[200px] py-2">
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Get Started
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Security Overview
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link"
								href="#" tabindex="0">
								<span class="kt-menu-title">
									Allowed IP Addresses
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Privacy Settings
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Device Management
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link"
								href="#" tabindex="0">
								<span class="kt-menu-title">
									Backup & Recovery
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Current Sessions
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Security Log
								</span>
							</a>
						</div>
					</div>
				</div>
				<div class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent"
					data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
					data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
					<div class="kt-menu-link gap-1.5 pb-2 lg:pb-4" tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							Members & Roles
						</span>
						<span class="kt-menu-arrow">
							<i class="ki-filled ki-down text-xs text-muted-foreground">
							</i>
						</span>
					</div>
					<div class="kt-menu-dropdown kt-menu-default min-w-[200px] py-2">
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Teams Starter
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Teams
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Team Info
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Members Starter
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Team Members
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Import Members
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Roles
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Permissions - Toggler
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Permissions - Check
								</span>
							</a>
						</div>
					</div>
				</div>
				<div
					class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent">
					<a class="kt-menu-link gap-2.5 pb-2 lg:pb-4" href="#"
						tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							Integrations
						</span>
					</a>
				</div>
				<div
					class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent">
					<a class="kt-menu-link gap-2.5 pb-2 lg:pb-4" href="#"
						tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							Notifications
						</span>
					</a>
				</div>
				<div
					class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent">
					<a class="kt-menu-link gap-2.5 pb-2 lg:pb-4" href="#"
						tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							API Keys
						</span>
					</a>
				</div>
				<div class="kt-menu-item kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono border-b-2 border-b-transparent"
					data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
					data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
					<div class="kt-menu-link gap-1.5 pb-2 lg:pb-4" tabindex="0">
						<span
							class="kt-menu-title kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono text-nowrap text-sm text-foreground">
							More
						</span>
						<span class="kt-menu-arrow">
							<i class="ki-filled ki-down text-xs text-muted-foreground">
							</i>
						</span>
					</div>
					<div class="kt-menu-dropdown kt-menu-default min-w-[200px] py-2">
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#" tabindex="0">
								<span class="kt-menu-title">
									Appearance
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#"
								tabindex="0">
								<span class="kt-menu-title">
									Invite a Friend
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="#" tabindex="0">
								<span class="kt-menu-title">
									Activity
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="flex items-center gap-5 text-sm text-foreground lg:pb-4">
		<a class="hover:text-primary" href="https://www.youtube.com/c/KeenThemesTuts/videos">
			Videos
		</a>
		<a class="hover:text-primary" href="https://keenthemes.com/metronic/tailwind/docs/">
			User Guides
		</a>
		<a class="hover:text-primary" href="https://devs.keenthemes.com">
			Support
		</a>
	</div>
</div>
<!-- End of Container -->
